/**
 * Prevent online rentals for today and tomorrow.
 *
 * SAS Rentals accepts online bookings from the third calendar day onward.
 * Urgent bookings are redirected to Instagram for manual confirmation.
 */
(function () {
  const DATE_INPUT_SELECTOR = '.izyDate.flatpickr-input, #startDate';
  const MILLISECONDS_PER_DAY = 86400000;
  const USER_SELECTION_WINDOW = 2000;
  let lastUserSelectionAt = 0;

  function getSydneyToday() {
    const parts = new Intl.DateTimeFormat('en-AU', {
      timeZone: 'Australia/Sydney',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).formatToParts(new Date());

    const values = {};
    parts.forEach((part) => {
      if (part.type !== 'literal') values[part.type] = Number(part.value);
    });

    return {
      year: values.year,
      month: values.month,
      day: values.day,
    };
  }

  function getSelectedDateParts(input) {
    const flatpickrDate = input._flatpickr?.selectedDates?.[0];
    if (flatpickrDate instanceof Date && !Number.isNaN(flatpickrDate.getTime())) {
      return {
        year: flatpickrDate.getFullYear(),
        month: flatpickrDate.getMonth() + 1,
        day: flatpickrDate.getDate(),
      };
    }

    const value = input.value.trim().split(/\s+to\s+/i)[0];
    if (!value) return null;

    let match = value.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
    if (match) {
      return {
        year: Number(match[1]),
        month: Number(match[2]),
        day: Number(match[3]),
      };
    }

    match = value.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})/);
    if (match) {
      return {
        year: Number(match[3]),
        month: Number(match[2]),
        day: Number(match[1]),
      };
    }

    const parsedDate = new Date(value);
    if (Number.isNaN(parsedDate.getTime())) return null;

    return {
      year: parsedDate.getFullYear(),
      month: parsedDate.getMonth() + 1,
      day: parsedDate.getDate(),
    };
  }

  function toDayNumber(dateParts) {
    return Date.UTC(dateParts.year, dateParts.month - 1, dateParts.day) /
      MILLISECONDS_PER_DAY;
  }

  function isUrgentBooking(selectedDate) {
    const daysAhead = toDayNumber(selectedDate) - toDayNumber(getSydneyToday());
    return daysAhead >= 0 && daysAhead < 2;
  }

  function clearRestrictedDate() {
    const flatpickrInput = document.querySelector('.izyDate.flatpickr-input');
    if (flatpickrInput?._flatpickr) {
      flatpickrInput._flatpickr.clear(false);
    } else if (flatpickrInput) {
      flatpickrInput.value = '';
    }

    const startDateInput = document.getElementById('startDate');
    if (startDateInput && startDateInput !== flatpickrInput) {
      startDateInput.value = '';
    }

    const rentalDateProperty = document.getElementById('izy_rent_start_date');
    if (rentalDateProperty) {
      rentalDateProperty.value = '';
    }
  }

  function checkSelectedDate(input) {
    const selectedDate = getSelectedDateParts(input);
    if (!selectedDate || !isUrgentBooking(selectedDate)) return;

    clearRestrictedDate();
    window.showUrgentBookingModal?.();
  }

  document.addEventListener('pointerdown', (event) => {
    if (event.target instanceof Element && event.target.closest('.flatpickr-day')) {
      lastUserSelectionAt = Date.now();
    }
  }, true);

  document.addEventListener('keydown', (event) => {
    if (
      event.key === 'Enter'
      && event.target instanceof Element
      && event.target.closest('.flatpickr-calendar, .flatpickr-input')
    ) {
      lastUserSelectionAt = Date.now();
    }
  }, true);

  document.addEventListener('change', (event) => {
    if (!(event.target instanceof Element) || !event.target.matches(DATE_INPUT_SELECTOR)) {
      return;
    }

    const followedUserSelection = Date.now() - lastUserSelectionAt <= USER_SELECTION_WINDOW;
    if (!event.isTrusted && !followedUserSelection) return;

    lastUserSelectionAt = 0;
    window.setTimeout(() => checkSelectedDate(event.target), 0);
  });
})();
